import { LaunchProofReportV1Schema, } from "../contracts/launch-proof-report.js";
import { InternalLaunchProofViewV1Schema, } from "../contracts/launch-proof-views.js";
import { composeLaunchProofSections, } from "./compose-launch-proof.js";
export function buildLaunchProofReport(input) {
    const sections = composeLaunchProofSections(input);
    return LaunchProofReportV1Schema.parse({
        schemaVersion: "launch-proof-report.v1.0",
        proofId: input.proofId,
        agencyId: input.agencyId,
        projectId: input.projectId,
        proofReferenceLabel: input.proofReferenceLabel,
        aggregateStatus: sections.aggregateStatus,
        headline: sections.headline,
        phase1Sections: sections.phase1Sections,
        searchReadinessExcerpt: sections.searchReadinessExcerpt,
        departureKitSummary: input.departureKitSummary,
        qualityGateStatus: input.qualityGateStatus ?? input.searchReadinessQaStatus,
        managerExceptions: input.managerExceptions ? [...input.managerExceptions] : undefined,
        skippedChecks: input.skippedChecks ? [...input.skippedChecks] : undefined,
        clientMissingInfo: input.clientMissingInfo ? [...input.clientMissingInfo] : undefined,
        whatWeDoNotPromise: [...sections.whatWeDoNotPromise],
        launchProofDisclaimers: [...sections.launchProofDisclaimers],
        businessGraphRevisionId: input.businessGraphRevisionId,
        artifactSetHash: input.artifactSetHash,
        generatedAt: input.generatedAt,
    });
}
export function toInternalLaunchProofView(report) {
    return InternalLaunchProofViewV1Schema.parse({
        schemaVersion: "internal-launch-proof-view.v1.0",
        proofReferenceLabel: report.proofReferenceLabel,
        aggregateStatus: report.aggregateStatus,
        headline: report.headline,
        phase1Sections: report.phase1Sections,
        searchReadinessExcerpt: report.searchReadinessExcerpt,
        departureKitSummary: report.departureKitSummary,
        qualityGateStatus: report.qualityGateStatus,
        managerExceptions: report.managerExceptions,
        skippedChecks: report.skippedChecks,
        clientMissingInfo: report.clientMissingInfo,
        whatWeDoNotPromise: report.whatWeDoNotPromise,
        launchProofDisclaimers: report.launchProofDisclaimers,
        agencyId: report.agencyId,
        projectId: report.projectId,
        businessGraphRevisionId: report.businessGraphRevisionId,
        artifactSetHash: report.artifactSetHash,
        generatedAt: report.generatedAt,
        clientSafe: false,
    });
}
export function buildInternalLaunchProofView(input) {
    return toInternalLaunchProofView(buildLaunchProofReport(input));
}
//# sourceMappingURL=build-launch-proof-report.js.map